import script from "./vxeTable.vue?vue&type=script&setup=true&lang=js"
export * from "./vxeTable.vue?vue&type=script&setup=true&lang=js"

import "./vxeTable.vue?vue&type=style&index=0&id=660dca26&scoped=true&lang=scss"
import "./vxeTable.vue?vue&type=style&index=1&id=660dca26&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-660dca26"]])

export default __exports__